import SectionHeader from "./SectionHeader";
import { WORKFORCE_GALLERY } from "@/lib/brand";

export default function WorkforceGallery() {
  return (
    <section
      className="bg-white py-16 md:py-24"
      data-testid="workforce-gallery-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Workforce in action"
          title="Skilled men & women powering Indian industries"
          description="From welding and metal fabrication to auto assembly and paint shops — our deployed workforce supports manufacturing, automotive, and industrial operations across the country."
          testid="workforce-gallery-header"
        />

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {WORKFORCE_GALLERY.map((img, i) => (
            <figure
              key={img.src}
              data-testid={`workforce-gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-sm border border-[#E2E8F0] bg-[#F8FAFC] rk-fade-up ${
                i === 0 ? "lg:row-span-2 lg:col-span-2 aspect-[4/5] lg:aspect-auto" :
                i === 3 ? "md:col-span-1 lg:col-span-2 aspect-[4/5] lg:aspect-[2/1]" :
                "aspect-[4/5]"
              }`}
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-[#0F172A]/0 to-transparent opacity-90" />
              <figcaption className="absolute bottom-3 left-3 right-3 text-white">
                <div className="text-[10px] tracking-widest uppercase font-bold text-[#67e8c4]">
                  RK Workforce
                </div>
                <div className="font-display font-bold text-sm sm:text-base mt-0.5">
                  {img.caption}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
